exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dynamic-fileupload{height:48px}.dynamic-fileupload .custom-file-label{height:48px;border-radius:3px;border:1px solid #dee2e6;background-color:#fff;color:#979797}.dynamic-fileupload .custom-file-label .form-file-text{line-height:34px}.dynamic-fileupload .custom-file-label:after{content:\"Buscar\"!important;height:46px;line-height:33px;border:1px solid #da325a;border-radius:0 3px 3px 0;background-color:#fff}.dynamic-fileupload .custom-file-label:after:hover{background-color:#da325a;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20e5b3aa","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicForms/FileUpload.vue
// module id = 787
// module chunks = 3